import { EntitySponsor } from "../../entity/EntitySponsor";

export class DtoSponsorsPutRes extends EntitySponsor {}
